import { useCallback, useState } from 'react'
import { clickAudio } from 'components/Selfiebooth/utils/helpers'
import useCameraStream, { FacingMode } from '../../../hooks/useCameraStream'

const useCamera = () => {
  const [isCapturing, setIsCapturing] = useState<boolean>(false);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const {
    stream,
    facingMode,
    error,
    startCamera: openCamera,
    stopCamera,
    switchCamera,
  } = useCameraStream({ initialFacingMode: "user" });

  const startCamera = useCallback(async (mode?: FacingMode) => {
    const mediaStream = await openCamera(mode);
    if (mediaStream) {
      setPhotoUrl(null)
    }
  }, [openCamera]);

  const cancelPhoto = useCallback(() => {
    if(photoUrl) {
      setPhotoUrl(null)
    }
  }, [photoUrl]);

  const capturePhoto = useCallback(async (video: HTMLVideoElement | null) => {
    if(!stream || !video) return;

    clickAudio();
    setIsCapturing(true);

    const canvas = document.createElement('canvas');

    const targetWidth = 400;
    const targetHeight = 400;

    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const aspectRatio = videoWidth / videoHeight;

      let sx = 0, sy = 0, sWidth = videoWidth, sHeight = videoHeight;

      if (aspectRatio > 1) {
        sWidth = sHeight * (targetWidth / targetHeight);
        sx = (videoWidth - sWidth) / 2;
      } else {
        sHeight = sWidth * (targetHeight / targetWidth);
        sy = (videoHeight - sHeight) / 2;
      }

      if (facingMode === "user") {
        ctx.translate(targetWidth, 0);
        ctx.scale(-1, 1);
      }

      ctx.drawImage(
        video,
        sx, sy, sWidth, sHeight,
        0, 0, targetWidth, targetHeight
      );
    }

    const photoUrl = canvas.toDataURL('image/jpeg');
    setPhotoUrl(photoUrl);

    stopCamera();

    await new Promise(resolve => setTimeout(resolve, 2000));

    setIsCapturing(false);
  }, [stream, facingMode, stopCamera]);

  return { startCamera, stream, stopCamera, capturePhoto, isCapturing, photoUrl, cancelPhoto, setPhotoUrl, errorCamera: error !== null, switchCamera };
}

export default useCamera;
